import type React from 'react';
import { Breadcrumbs, Panel, PanelBody } from '@itandi/itandi-bb-ui';
import Link from 'next/link';
import { VendorSettingLayout } from '~/components/common/layouts/settings/VendorSettingLayout';
import { VendorLayoutV2 } from '~/components/common/layouts/VendorLayoutV2';
import { PATH as COMPANY_SETTINGS_PATH } from '~/pages/vendors/settings/company_settings';
import { ConstructionItemSettingList } from './ConstructionItemSettingList';
import SettingStyles from '../../SettingStyle.module.scss';
import { PATH as SETTING_PATH } from '~/pages/vendors/settings';

export const Page: React.FC = () => (
  <VendorLayoutV2>
    <VendorSettingLayout>
      <div className={SettingStyles.PcBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            {
              label: '提携中の管理会社一覧',
              as: Link,
              href: COMPANY_SETTINGS_PATH
            },
            { label: '工事単価一覧' }
          ]}
        />
      </div>
      <div className={SettingStyles.SpBreadcrumbsWrapper}>
        <Breadcrumbs
          items={[
            { label: '設定一覧', as: Link, href: SETTING_PATH },
            {
              label: '提携中の管理会社一覧',
              as: Link,
              href: COMPANY_SETTINGS_PATH
            },
            { label: '工事単価一覧' }
          ]}
        />
      </div>
      <Panel>
        <PanelBody>
          <ConstructionItemSettingList />
        </PanelBody>
      </Panel>
    </VendorSettingLayout>
  </VendorLayoutV2>
);
